export default {"src":"/_next/static/media/ousg.5820882e.svg","height":160,"width":160,"blurWidth":0,"blurHeight":0};